import qs from 'qs';
import { apiClient, attachFileUrl, estateUrl, estatePropsUrl } from '../http-common';
import { isNumeric } from '@/helpers';
export function attachFile(file) {
    return new Promise((resolve, reject) => {
        apiClient.post(attachFileUrl, file).then((response) => {
            if (response.status === 201) {
                resolve(response.data);
            }
        });
    });
}
export function attachFileUpdate(payload) {
    return new Promise((resolve, reject) => {
        apiClient.put(attachFileUrl, payload).then((response) => {
            if (response.status === 201) {
                resolve(response.data);
            }
        });
    });
}
export function getEstateProps() {
    return new Promise((resolve, reject) => {
        apiClient.get(estatePropsUrl).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}
export function getListEstates(payload) {
    // TODO - Quick fix to show all
    payload.limit = 30;
    return new Promise((resolve, reject) => {
        apiClient.get(`${estateUrl}s`, {
            params: payload,
            paramsSerializer: params => qs.stringify(params, {
                arrayFormat: 'brackets',
                encode: false
            })
        }).then(response => {
            if (response.status === 200) {
                resolve(response.data);
            }
        }).catch(err => reject(err));
    });
}
export function getSingleEstate(id) {
    const endpoint = isNumeric(id)
        ? `${estateUrl}/${id}`
        : `${estateUrl}/getFromUuid/${id}`;
    return new Promise((resolve, reject) => {
        apiClient.get(endpoint).then(response => {
            if (response.status === 200) {
                resolve(response.data);
            }
        }).catch(err => reject(err));
    });
}
export function getNumberOfAvailableEstates() {
    return new Promise((resolve, reject) => {
        apiClient.get(`${estateUrl}s/numberOfAvailableEstates`).then(response => {
            if (response.status === 200) {
                resolve(response.data.data);
            }
        }).catch(err => reject(err));
    });
}
export function createEstate(payload) {
    return new Promise((resolve, reject) => {
        apiClient.post(estateUrl, payload).then(response => {
            if (response.status === 201) {
                resolve(response.data);
            }
        }).catch(err => reject(err));
    });
}
export function updateEstate(payload) {
    const { id } = payload;
    return new Promise((resolve, reject) => {
        apiClient.put(`${estateUrl}/${id}`, payload).then(response => {
            if (response.status === 200) {
                resolve(response.data);
            }
        }).catch(err => reject(err));
    });
}
export function deleteEstate(id) {
    return new Promise((resolve, reject) => {
        apiClient.delete(`${estateUrl}s`, { params: { id: id } }).then(response => {
            if (response.status === 200) {
                resolve(response.data);
            }
        }).catch(err => reject(err));
    });
}
export function setState(obj) {
    return new Promise((resolve, reject) => {
        apiClient.put(`${estateUrl}/${obj.estateId}`, { state: obj.stateId }).then(response => {
            if (response.status === 200) {
                resolve(response.data);
            }
        }).catch(err => reject(err));
    });
}
